import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const SigninWithUsername = (props) => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });
  
  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }
    console.log("userData: ", userData);
    //post to server
    try {
      setLoading(true);
      const response = await axios.post("php/sign_in/signin.php", userData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);
      
      if (response.data.code !== 200) {

        if (response.data.code === 401) {
          alert(response.data?.message || "Invalid credentials. Retry or use password help")
        } else {
          alert(
            response.data?.message ||
              "Failed to sign in. Check your internet connection and retry",
          );
        }                 
        return;
      }
      
      props.onLoggedIn({
        method: "username",
        callname: response.data.callname,
      });
      
    } catch (error) {
      const data = error?.response?.data;

      alert(data?.message || "Invalid credentials or Error connecting to server. Please retry.");
    } finally {
      setLoading(false)
    }
  };

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim().toLowerCase() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));
  };  

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Username</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="username">Username</label>
        <input
          id="username"
          type="text"
          placeholder="Enter your username"
          maxLength={24}
          required
          autoComplete="username"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onUsernamePasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithUsername;

/* 2025 standard
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const SigninWithUsername = (props) => {
  const [showSpinner, setShowSpinner] = useState();
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const [checked, setChecked] = useState(false);
  const checkboxType = (type) => {
    type === "password" ? (type = "text") : (type = "password");
    return type;
  };

  const checkboxChangeHandler = () => {
    const passwordInput = document.getElementById("password");
    setChecked(!checked);
    passwordInput.type = checkboxType(passwordInput.type);
  };

  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }
    console.log("userData: ", userData);
    //post to server
    try {
      setShowSpinner(true);
      const response = await axios.post("php/sign_in/signin.php", userData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // Check the response
      console.log("response data: ", response.data);
      if (response.data == "Access denied" || response.data == 0) {
        alert(
          "Error connecting to server. Check your internet connection or retry later"
        );
      } else if (response.data == 1) {
        alert("Wrong username. Retry");
      } else if (response.data == 2) {
        alert("Wrong password. Retry");
      } else {
        props.onLoggedIn({
          method: "username",
          callname: response.data,
        });
      }
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      alert(`Error: ${error} Please retry`);
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Username</h2>
      </header>
      <div className={styles.inputView}>
        <label htmlFor="username">Username</label>
        <input
          id="username"
          placeholder="Enter your username"
          maxLength={24}
          required
          autoComplete="off"
          value={userData.uid}
          onChange={(e) =>
            setUserData({
              ...userData,
              uid: e.target.value.trim().toLowerCase(),
            })
          }
        />
      </div>
      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            type="password"
            id="password"
            placeholder="Enter your password"
            maxLength={15}
            required
            autoComplete="off"
            value={userData.password}
            onChange={(e) =>
              setUserData({
                ...userData,
                password: e.target.value.trim(),
              })
            }
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={checked}
            onChange={checkboxChangeHandler}
          />
        </div>
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
        >
          Submit
        </button>
        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onUsernamePasswordHelpRequest}
        >
          Password help
        </button>
        <button className={styles.bgRed} onClick={props.onCancel}>
          Cancel
        </button>
      </div>
      {showSpinner && <Spinner />}
    </div>
  );
};

export default SigninWithUsername;
*/

/* 03-2026 being abandoned
import SigninCredentialBase from "./SigninCredentialBase";

const normalizeUsername = (value) => value.trim().toLowerCase();

const validateUsername = (value) => value.trim().length > 0;

const SigninWithUsername = (props) => {
  return (
    <SigninCredentialBase
      title="Sign in with your Username"
      uidLabel="Username"
      uidInputId="username"
      uidInputType="text"
      uidPlaceholder="Enter your username"
      uidMaxLength={24}
      uidAutoComplete="username"
      method="username"
      normalizeUid={normalizeUsername}
      validateUid={validateUsername}
      invalidUidMessage="Your username is invalid"
      passwordHelpHandler={props.onUsernamePasswordHelpRequest}
      onCancel={props.onCancel}
      onLoggedIn={props.onLoggedIn}
    />
  );
};

export default SigninWithUsername;
*/

/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import { useAuthSubmit } from "../../../../auth/useAuthSubmit";

const SigninWithUsername = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const { submit, loading } = useAuthSubmit(
    "php/sign_in/signin.php",
    "username",
    props.onLoggedIn,
  );

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim().toLowerCase() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));
  };

  const submitHandler = () => {
    if (loading) return;

    const uid = userData.uid.trim().toLowerCase();
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill all fields correctly.");
      return;
    }

    submit({
      uid,
      password,
    });
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Username</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="username">Username</label>
        <input
          id="username"
          type="text"
          placeholder="Enter your username"
          maxLength={24}
          required
          autoComplete="username"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onUsernamePasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithUsername;

/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import { useAuthSubmit } from "../../../../auth/useAuthSubmit";

const SigninWithUsername = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const { submit, loading } = useAuthSubmit(
    "php/sign_in/signin.php",
    "username",
    props.onLoggedIn,
  );

  const inputChangeHandler = (field, value) => {
    setUserData((prev) => ({
      ...prev,
      [field]: field === "uid" ? value.trim().toLowerCase() : value,
    }));
  };

  const submitHandler = () => {
    const uid = userData.uid.trim().toLowerCase();
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill in both username and password.");
      return;
    }

    submit({ uid, password });
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") submitHandler();
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Username</h2>
      </header>

      <div className={styles.inputView}>
        <label>Username</label>
        <input
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
      </div>

      <div className={styles.inputView}>
        <label>Password</label>
        <div className={styles.flex}>
          <input
            type={showPassword ? "text" : "password"}
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((p) => !p)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onEmailPasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithUsername; 
*/
/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const SigninWithUsername = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const inputChangeHandler = (field, value) => {
    setUserData((prev) => ({
      ...prev,
      [field]: field === "uid" ? value.trim().toLowerCase() : value,
    }));
  };

  const submitHandler = async () => {
    if (showSpinner) return;

    const uid = userData.uid.trim().toLowerCase();
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill in both username and password.");
      return;
    }

    try {
      setShowSpinner(true);

      const res = await axios.post(
        "php/sign_in/signin.php",
        { uid, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );

      console.log("Server response:", res.data);

      if (res.data?.status !== "success") {
        throw new Error(res.data?.message || "Sign-in failed.");
      }

      props.onLoggedIn({
        method: "username",
        callname: res.data.callname,
      });
    } catch (error) {
      console.error("Sign-in error:", error);

      const message =
        error.response?.data?.message ||
        error.message ||
        "Please retry or use another method.";

      alert(`Your sign-in credential failed. ${message}`);
    } finally {
      setShowSpinner(false);
    }
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Username</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="username">Username</label>
        <input
          id="username"
          type="text"
          placeholder="Enter your username"
          maxLength={24}
          required
          autoComplete="username"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={showSpinner}
        />
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={15}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={showSpinner}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={showSpinner}
        >
          {showSpinner ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onUsernamePasswordHelpRequest}
          disabled={showSpinner}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={showSpinner}
        >
          Cancel
        </button>
      </div>

      {showSpinner && <Spinner />}
    </div>
  );
};

export default SigninWithUsername;
*/
